import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidepanel-collapse",
  "use": "icon-sidepanel-collapse-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-sidepanel-collapse\"><path d=\"m10.4 10 4.6 4.6c.8.8.8 2 0 2.8L10.4 22 9 20.6l4.6-4.6L9 11.4zm6.8 0 4.6 4.6c.8.8.8 2 0 2.8L17.2 22l-1.4-1.4 4.6-4.6-4.6-4.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol